import { Divider, Theme, useMediaQuery } from "@material-ui/core";
import { ReduxState } from "ra-core";
import React, { FC, useEffect } from "react";
import {
  MenuItemLink,
  setSidebarVisibility,
  usePermissions,
} from "react-admin";
import { useDispatch, useSelector } from "react-redux";
import DashIcon from "@material-ui/icons/Dashboard";
import { makeStyles } from "@material-ui/core/styles";
import "./menu.scss";
import WtsIcon from "../icons/WtsIcon";
import MenuStructure from "./components/MenuStructure";
import PermissionLoading from "../PermissionLoading";
import CustomSidebarToggleButton from "./components/CustomSidebarToggleButton";

export type ThemeName = "light" | "dark";
export interface AppState extends ReduxState {
  theme: ThemeName;
}

interface Props {
  dense: boolean;
  logout: () => void;
  onMenuClick: () => void;
}

const useStyles = makeStyles({
  wtsIcon: {
    padding: "10px 5px 20px 5px",
    "& svg": {
      width: (open) => (open ? "100%" : "undefined"),
    },
  },
  divider: { backgroundColor: "#F4F7FE", margin: "10px 0px 25px 0px" },
});

const Menu: FC<Props> = ({ logout }) => {
  const open = useSelector((state: AppState) => state.admin.ui.sidebarOpen);
  const router = useSelector((state: AppState) => state.router);
  const classes = useStyles(open);
  const isXSmall = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("xs"),
  );
  const dispatch = useDispatch();

  useEffect(() => {
    const splittedValue = router.location.pathname.split("/");

    if (splittedValue[1] === "busSchedulePlans" && splittedValue.length >= 3) {
      dispatch(setSidebarVisibility(false));
      return;
    }

    if (
      splittedValue[1] === "enhancedBusSchedulePlans" &&
      splittedValue.length >= 3
    ) {
      dispatch(setSidebarVisibility(false));
      return;
    }

    dispatch(setSidebarVisibility(true));
    localStorage.removeItem("routePlanVersion");

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router]);

  const { permissions, loading } = usePermissions();
  if (loading) {
    return <PermissionLoading />;
  }

  return (
    <div>
      <CustomSidebarToggleButton />
      <WtsIcon className={classes.wtsIcon} />

      <Divider className={classes.divider} />

      <MenuItemLink
        to={`/dashboard`}
        primaryText={"Dashboard"}
        leftIcon={<DashIcon />}
      />

      <MenuStructure permissions={permissions} />

      {isXSmall && logout}
    </div>
  );
};

export default Menu;
